import { useCallback, useEffect, useState } from "react";
import { getDisponibles } from "../service/empleadoViandasService";

export function useDisponiblesSemana(desde, hasta) {
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const fetchData = useCallback(async () => {
    if (!desde || !hasta) return;
    setLoading(true);
    setError(null);
    try {
      const res = await getDisponibles(desde, hasta);
      setData(res || []);
    } catch (err) {
      setError(err);
    } finally {
      setLoading(false);
    }
  }, [desde, hasta]);

  useEffect(() => {
    fetchData();
  }, [fetchData]);

  return { data, loading, error, refresh: fetchData };
}
